export enum PostMessageType {
  HEIGHT_CHANGED = "HEIGHT_CHANGED",
}

// console.log('window.__PATH__?.appUrls.pageDesigner', window.__PATH__?.appUrls.pageDesigner);
export const BASE_URL = process.env.NODE_ENV === "production" ? window.__PATH__?.appUrls.pageDesigner : "http://localhost:1555/";

export const API_URL = BASE_URL + "PageDesigner/Api";
// console.log('API_URL', API_URL);
